import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { apiRoutes } from 'src/app/constants/apiRoutes';
import { ApiCallMethodsService } from '../../services/api-call-methods.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SidenavThemeServiceService } from '../../services/sidenav-theme-service/sidenav-theme-service.service';
import { ToggleServiceService } from '../../services/toggle-service/toggle-service.service';
import { Subscription } from 'rxjs';
import { MainService } from 'src/app/main/services/main.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    hideHeaderRoutes = ['test-builder'];
    isDetailsPage: any = null;
    showHeader: any = true;
    isSticky: boolean = false;
    headerName: string = '';
    orgCategory: string = '';
    userDetails: any;
    sellerId: any;
    getSellerDetails: any;

    isToggled = false;
    orgId: any;
    companyProfileDetails: any;
    sharingData: Subscription;
    isLoading: boolean = false;
    companyData: any = null;
    orgName: any = null;
    orgLogo: any = null;
    isBusinessMenuOpen: boolean = false;
    isProfileMenuOpen: boolean = false;
    isMenuOpen: boolean = false;
    isMenuUnavailable: boolean = false;

    private megaMenuLoaded = false;

    constructor(private authService: AuthService, private router: Router,
        private apiCallMethodsService: ApiCallMethodsService,
        private _snackBar: MatSnackBar,
        private toggleService: ToggleServiceService,
        public themeService: SidenavThemeServiceService,
        private mainService: MainService,
        private http: HttpClient
    ) {
        this.toggleService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.userDetails = this.authService.getSessionDetail();
        const logo = localStorage.getItem('orgLogo');
        this.orgLogo = (logo === 'null' || logo === 'undefined' || !logo) ? null : logo;

        if (this.userDetails) {
            this.orgId = this.authService.getId();

            this.mainService.getCompanyDetails();
            this.mainService.getCompanyName()
            this.companyData = this.mainService.companyData?.org;
        }

        this.sharingData = this.mainService.SharingData.subscribe((response: any) => {
            this.isLoading = false;

            if (response.company) {
                this.companyProfileDetails = response?.company?.data?.orgProfile;
                this.authService.setId(this.orgId);

            };

            if (response.orgList) {
                this.companyData = response?.orgList?.org;
                const selectedCompany = this.companyData.find(company => company.org_id === this.orgId);
                this.orgName = selectedCompany?.org_name || '';
            };

        });

    };

    navigateToMyProfile() {
        let url = environment.ssoUrl + 'my-profile';
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    redirectToSecurity() {
        let url = environment.ssoUrl + 'security';
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    getCompanyName() {
        let orgProfileUrl = apiRoutes.orgProfile + '/' + this.userDetails?.user?.user_id;
        this.apiCallMethodsService.get(orgProfileUrl).subscribe((response: any) => {
            this.companyData = response?.org;
            const selectedCompany = this.companyData.find(company => company.org_id === this.orgId);
            this.orgName = selectedCompany?.org_name || '';
        });
    }

    setSelectedOrg(orgIds: any, orgName: string, orgLogo) {
        this.orgId = orgIds;
        this.authService.setId(orgIds);
        this.orgName = orgName;

        localStorage.setItem('orgLogo', orgLogo);

        let sessionDetail = this.authService.getSessionDetail();
        if (sessionDetail && sessionDetail.user) {
            sessionDetail.user.org_id = orgIds;
            const selectedCompany = this.companyData?.find(company => company.org_id === orgIds);
            if (selectedCompany && selectedCompany.user_id) {
                sessionDetail.user.user_id = selectedCompany.user_id;
            }
            this.authService.setToken(sessionDetail);
        }

        setTimeout(() => {
            this.router.navigate(['/sales']).then(() => {
                window.location.reload();
            });

        }, 200)
    }

    getCompanyDetails() {
        let url = apiRoutes.selectedOrgProfile + '/' + this.orgId;
        this.apiCallMethodsService.get(url).subscribe((response: any) => {
            this.companyProfileDetails = response?.data[0];
            console.log(this.companyProfileDetails);

            this.authService.setId(this.orgId);
            this.orgName = this.getOrgName(this.orgId);
        });
    }

    getOrgName(orgId: any) {

        const selectedCompany = this.companyData?.find(company => company.org_id == orgId);

        return selectedCompany?.org_name || '';

    }

    getOrgLogo(orgId: any) {

        const selectedCompany = this.companyData?.find(company => company.org_id == orgId);

        return selectedCompany?.org_image_link || '';

    }
    navigateToDetailsPage(supplierId: any) {
        this.router.navigate(['/sales/business-management'], { queryParams: { id: supplierId } });
    }
    redirectToBusinessManagement() {
        this.router.navigate(['/company-register']);
    }

    // Close dropdown when clicking anywhere outside the business-switcher trigger
    @HostListener('document:click')
    onDocumentClick() {
        this.isBusinessMenuOpen = false;
        this.isProfileMenuOpen = false;
    }

    toggleBusinessMenu(event: MouseEvent) {
        event.stopPropagation();
        this.isBusinessMenuOpen = !this.isBusinessMenuOpen;
        this.isProfileMenuOpen = false;
    }

    toggleProfileMenu(event: MouseEvent) {
        event.stopPropagation();
        this.isProfileMenuOpen = !this.isProfileMenuOpen;
        this.isBusinessMenuOpen = false;
    }

    get userInitials(): string {
        const name = this.userDetails?.user?.name || this.userDetails?.user?.user_name || '';
        return name.trim().charAt(0).toUpperCase();
    }

    // logOut() {
    //     this.authService.removeId();
    //     this.authService.removeToken();
    //     this.router.navigateByUrl('login', { replaceUrl: true });
    // }

    logout() {
        this.authService.globalLogout(true);
    }


    collapseNav() {
        document.querySelector('.mat-drawer-container').classList.toggle('collapsed');
    }


    ngOnInit(): void {
    }



    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggle() {
        this.toggleService.toggle();
    }

    // logout() {
    //     this.authService.removeToken();
    //     this.authService.removeId();

    //     setTimeout(() => {
    //         this.router.navigate(['login']);
    //     }, 200);

    //     window.location.reload()
    // }



    openSidebar() {
        document.querySelector('.sidebar-area').classList.add('mobile-open');
        document.querySelector('.overlay').classList.add('mobile-open');
    }

    closeSidebar() {
        document.querySelector('.sidebar-area').classList.remove('mobile-open');
        document.querySelector('.overlay').classList.remove('mobile-open');
    }

    toggleMenu(event: MouseEvent) {
        event.stopPropagation();
        this.isMenuOpen = !this.isMenuOpen;
        if (this.isMenuOpen && !this.megaMenuLoaded && !this.isMenuUnavailable) {
            this.loadMegaMenuScript();
        }
    }

    private loadMegaMenuScript() {
        try {
            const script = document.createElement('script');
            script.src = `${environment.megaMenuUrl}/assets/index.js?t=${Date.now()}`;
            script.type = 'module';
            script.onload = () => {
                this.megaMenuLoaded = true;
                console.log('Mega Menu MFE loaded');
            };
            script.onerror = () => {
                console.warn('Mega Menu MFE failed to load');
                this.isMenuUnavailable = true;
                this.isMenuOpen = false;
            };
            document.head.appendChild(script);
        } catch (error) {
            console.error('Error injecting Mega Menu script:', error);
            this.isMenuUnavailable = true;
            this.isMenuOpen = false;
        }
    }

    onMegaMenuClose() {
        this.isMenuOpen = false;
    }
}
